import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration will go here
const firebaseConfig = {
   apiKey: "AIzaSyDHZs2SigvMNizEtsCyhUdZMFQ3PnzeuTE",
   authDomain: "squirrel-spotter-14758.firebaseapp.com",
   projectId: "squirrel-spotter-14758",
   storageBucket: "squirrel-spotter-14758.firebasestorage.app",
   messagingSenderId: "533145847926",
   appId: "1:533145847926:web:c395b58ebc6a8c28393757"
 };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app; 